import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar traducciones en español
import esCommon from './locales/es/common.json';
import esAuth from './locales/es/auth.json';
import esForms from './locales/es/forms.json';
import esErrors from './locales/es/errors.json';
import esDialogs from './locales/es/dialogs.json';
import esMenu from './locales/es/menu.json';
import esQr from './locales/es/qr.json';

// Importar traducciones en alemán
import deCommon from './locales/de/common.json';
import deAuth from './locales/de/auth.json';
import deForms from './locales/de/forms.json';
import deErrors from './locales/de/errors.json';
import deDialogs from './locales/de/dialogs.json';
import deMenu from './locales/de/menu.json';
import deQr from './locales/de/qr.json';

i18n
  .use(LanguageDetector) // Detecta idioma del navegador
  .use(initReactI18next) // Pasa i18n a react-i18next
  .init({
    resources: {
      es: {
        common: esCommon,
        auth: esAuth,
        forms: esForms,
        errors: esErrors,
        dialogs: esDialogs,
        menu: esMenu,
        qr: esQr
      },
      de: {
        common: deCommon,
        auth: deAuth,
        forms: deForms,
        errors: deErrors,
        dialogs: deDialogs,
        menu: deMenu,
        qr: deQr
      }
    },
    fallbackLng: 'es', // Idioma por defecto
    defaultNS: 'common', // Namespace por defecto
    interpolation: {
      escapeValue: false // React ya escapa por defecto
    },
    detection: {
      // Orden de detección: query string > localStorage > navegador
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'], // Guardar preferencia en localStorage
      lookupQuerystring: 'lng', // Parámetro en URL: ?lng=de
      lookupLocalStorage: 'i18nextLng' // Key en localStorage
    },
    debug: false // Cambiar a true para debugging
  });

export default i18n;
